app.controller("StudentNewTimetableController", ["$scope", "StSubject", "Users", "AuthService", "Session", "StaticData", "$state",
    function ($scope, StSubject, Users, AuthService, Session, StaticData, $state) {

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.days = days;
            $scope.daysMap = _.keyBy($scope.days, '_id');
        });

        StaticData.getItemsByKey("session_types").then(function (sessionTypes) {
            $scope.sessionTypes = sessionTypes;
            $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            $scope.buildings = [{name: "კორპუსი"}].concat(buildings);
            $scope.buildingsMap = _.keyBy($scope.buildings, '_id');
        });

        Session.studentSessions().then(function (sessions) {
            sessions.map(function (session) {
                // if (session.dayOfWeek) session.day = $scope.daysMap[session.dayOfWeek].name;
                if (session.sessionGroup.lecturer) session.lecturer = session.sessionGroup.lecturer.user.firstName + " " + session.sessionGroup.lecturer.user.lastName;
                if (session.sessionGroup.subjectWrapper) session.subject = session.sessionGroup.subjectWrapper.name;
            });
            $scope.sessions = sessions;
            $scope.sessionsByDays = _.groupBy(sessions, 'dayOfWeek');
        });
    }
]);